import { toast } from "react-toastify";
import { textCase } from "../../../service/ui/UI";

export default class ShowToast {
  static success = (msg: string) => {
    toast.success(textCase(msg), { position: "bottom-right", theme: "dark" });
  };

  static info = (msg: string) => {
    toast.info(textCase(msg), { position: "bottom-right", theme: "dark" });
  };

  static error = (msg: string) => {
    toast.error(textCase(msg), { position: "bottom-right", theme: "dark" });
  };

  static warning = (msg: string) => {
    toast.warn(textCase(msg), { position: "bottom-right", theme: "dark" });
  };
}

/* toast.success('This is a success message!');
toast.error('This is an error message!');
toast.info('This is an info message!');
toast.warn('This is a warning!'); */
